<template>
  <el-dialog
    close="log_type"
    title="日志类型"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="dialogVisible"
    width="60%"
  >
    <el-row v-loading="loading" :gutter="24">
      <el-col class="log_type-item" :span="6" v-for="type in typeList" :key="type.dataSourceId">
        <el-card class="log_type-card" shadow="hover" @click.native="onClickDetail(type)">
          <div class="log_type-card-inner">
            <div class="type-icon">
              <img class="icon-document" :src="onGetImg(type)" />
            </div>
            <div class="log_type-card-text">
              <p class="log_type-card-text-title">{{ type.displayName }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <template #footer>
      <el-button @click="dialogVisible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { reqFetchDatasources } from '../../../api/datasource';

export default {
  name: 'LogTypeSelector',

  data() {
    return {
      dialogVisible: false,
      typeList: [],
      loading: false
    };
  },

  methods: {
    open() {
      this.dialogVisible = true;
      this.getDataSourceList();
    },
    async getDataSourceList() {
      try {
        this.loading = true;
        const { data } = await reqFetchDatasources();
        this.typeList = data;
      } finally {
        this.loading = false;
      }
    },
    onClickDetail(logType) {
      this.dialogVisible = false;
      window.sessionStorage.logType = JSON.stringify(logType);
      this.$emit('clickDetail');
    },
    onGetImg(type) {
      try {
        return require(`@/assets/icon/${type.name.toLowerCase()}.png`);
      } catch (e) {
        return require(`@/assets/icon/simple.png`);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.log_type {
  &-item {
    margin-bottom: 10px;
    white-space: nowrap;
  }

  &-card {
    background: #f9f9f9;
    cursor: pointer;

    &-inner {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .type-icon {
        width: 42px;
        height: 42px;
        flex-shrink: 0;

        .icon-document {
          width: 100%;
          height: 100%;
        }
      }
    }

    .el-icon-document {
      font-size: 42px;
      color: #28729e;
    }

    &-text {
      flex-shrink: 0;
      width: 100px;
      margin-left: 10px;

      &-title {
        font-size: 14px;
      }

      &-detail {
        font-size: 12px;
        color: #00a0ff;
      }
    }
  }
}
</style>
